<navigation [forceTitle]="'Subscription.Cert.Name' | translate"></navigation>
<div class="cert">
  <div class="container">
    <cert-header />
    <cert-tabs [activeTab]="activeTab()" (tabEmitter)="changeTab($event)"></cert-tabs>
    @if (showAirtScansTab()) {
      <scan-tab [prefixes]="prefixes()" />
    } @else if (showDdosFilterTab()) {
      <ddos-tab />
    } @else if (showDnsFirewallTab()) {
      <dns-firewall-tab [prefixes]="prefixes()" />
    } @else if (showCbwTab()) {
      <cbw-tab />
    }
    <footer></footer>
  </div>
</div>
